import { Cotizacion } from './cotizacion';

export class Moneda {
	idMoneda: number;
	idCliente: number;
	simbolo: string;
	columna: string;
	sistema: boolean;
	nombreDes: string;
	cotizaciones: Cotizacion[] = [];
	traducciones: string[] = [];
}
